module.exports = __webpack_public_path__ + "img/link-banner-de.cf416b11.png";